export default __webpack_public_path__ + "static/media/caret_down_2.8b811721.svg";